import {resource} from '@albert-io/json-api-framework/request/builder';
import appStore from 'client/AppStore';

export default {
  getAssignmentWithStudentQuestionMetaQuery() {
    const assignmentId = appStore.routerProps.params.examId;
    return resource('assignment_v3')
      .mandarkEndpoint(['assignments_v3', assignmentId])
      .include('sections_v1.question_sets_v1.questions_v2')
      .include('students_v2')
      .customQuery({
        with_meta: 'question_v2'
      })
      .customQuery({
        meta: {
          context: {
            student: {
              id: appStore.routerProps.params.studentId
            },
            assignment: {
              id: assignmentId
            }
          }
        }
      });
  },
  getActiveSectionById(sectionId) {
    return this.getAssignmentWithStudentQuestionMetaQuery()
      .getResource()
      .getSections()
      .find((section) => section.getId() === sectionId);
  }
};
